import { FundsOriginCodeEnum } from '../../../../common/enums/fundsOriginEnum'
import { IFundsOrigin } from '../../../../common/interfaces'

// "Otros" is identified by code, never by id/description: ids differ between environments.
export const isOtherFundsOrigin = (fundsOrigins: IFundsOrigin[], fundOriginId: number | '') =>
  fundsOrigins.find((fundsOrigin) => fundsOrigin.id === fundOriginId)?.code ===
  FundsOriginCodeEnum.OTHER
